<template>
  <div id="layout-basic">
    <header>
      <BasicHeader :current-user="currentUser" :subType='isHome'></BasicHeader>
    </header>
    <div>
      <router-view :key="key" />
    </div>
    <footer>
      <BasicFooter></BasicFooter>
    </footer>
    <a-back-top />
  </div>
</template>

<script>

import { mapState } from 'vuex'
import { BasicHeader, BasicFooter } from './modules';
export default {
  name: 'BasicLayout',
  components: {
    BasicHeader,
    BasicFooter
  },

  computed: {
    ...mapState({
      currentUser: state => state.user.info
    }),
    key() {
      return this.$route.path
    },
    isHome() {
      return this.$route.path == '/' ? false : true
    }
  },
}
</script>

<style scoped lang="less">
.wrap{
  margin: 0 auto;
  width: 1200px;
}

#layout-basic {
  overflow: hidden;
  padding: 0;
  width: 100%;

  ::v-deep .ant-back-top-content {
    background-color: #ffa500;
  }

}
</style>